<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat class="card-border">
          <h2>Заявки на комплексы в разрезе школ и типов питания</h2>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-card flat tile>
          <v-card-text>
            <v-toolbar flat>
              <v-menu offset-y bottom>
                <template v-slot:activator="{ on }">
                  <v-text-field
                  class="mx-3"
                  label="Выберите дату"
                  v-model="day"
                  v-on="on"
                  :disabled="inAction"
                  style="max-width: 220px"
                  hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                :disabled="inAction" locale="ru" first-day-of-week="1"
                v-model="day" :landscape="true" :reactive="true"
                ></v-date-picker>
              </v-menu>
              <v-btn
              color="primary"
              class="mx-5"
              :disabled="inAction || !day"
              @click="makeReport()"
              >Сформировать</v-btn>
              <v-btn
                @click="saveAs()"
                :disabled="inAction"
                v-if="inAction || (csv && requests && requests.length > 0)"
              >
                <template v-if="inAction">
                  Подождите... &nbsp;
                  <v-progress-circular
                  color="deep-purple accent-4"
                  :size="25" :value="progress"
                  ></v-progress-circular>
                </template>
                <template v-else>
                  <v-icon>save</v-icon>
                  <span>Сохранить CSV [{{csvfilename}}]</span>
                </template>
              </v-btn>
            </v-toolbar>
            <table
              v-if="requests.length > 0"
              width="100%"
              border="1"
              cellpadding="0"
              cellspacing="0"
              style="font-size:8pt;border-collapse:collapse;"
            >
              <tr align="left">
                <th>Столовая</th>
                <th>Тип питания</th>
                <th>Стоимость комплекса</th>
                <th>Кол-во заявок</th>
                <th>Итого</th>
              </tr>
              <tr v-for="item in requests">
                <td>{{item.cafe}}</td>
                <td>{{item.saletype}}</td>
                <td align="center">{{rubles(item.amount)}} &#8381;</td>
                <td align="center">{{item.requests}}</td>
                <td align="center">{{parseFloat(item.requests * rubles(item.amount)).toFixed(2)}} &#8381;</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td align="center">{{requests.reduce((a ,b) => a + parseInt(b.requests), 0)}}</td>
                <td align="center">{{rubles(requests.reduce((a, b) => a + parseInt(b.amount * b.requests), 0)).toString().replace('.', ',')}}</td>
              </tr>
            </table>
            <table v-else width="100%">
              <tr>
                <th>нет данных</th>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
const FileSaver = require('file-saver')
const encoding = require('encoding')

export default {
  name: 'RequestsByDay',
  data: () => ({
    day: null,
    inAction: false,
    progress: 0,
    requests: [],
    csv: null,
    csvfilename: null
  }),
  computed: {
    profile () {
      return this.$store.state.profile
    },
    orgid () {
      return this.profile ? this.profile.orgid : null
    },
  },
  methods: {
    asyncTimeout (to) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, to)
      })
    },
    async makeReport () {
      try {
        this.requests = []
        const day = this.day
        if (!day) throw new Error('Выберите дату')
        this.progress = 1
        this.inAction = true
        await this.asyncTimeout(500)
        const { cafes } = await this.$store.dispatch('sioRequest', {
          topic: 'org-cafes',
          pl: {}
        })
        this.csv = `Столовая;Тип питания;Стоимость комплекса;Кол-во заявок;Итого\n`
        for await (const cafe of cafes) {
          const { report } = await this.$store.dispatch('sioRequest', {
            topic: 'org-report-by-requests',
            pl: {
              day: this.day,
              orgid: this.orgid,
              cafeid: cafe.cafeid
            }
          })
          report.forEach(x => {
            this.csv += `${x.cafe};${x.saletype};${this.rubles(x.amount).toString().replace('.', ',')};${x.requests};${parseFloat(x.requests * this.rubles(x.amount)).toFixed(2).toString().replace('.', ',')}\n`
          })
          if (report.length > 0) {
            this.requests.push(...report)
          }
        }
        this.csvfilename = `${this.orgid}-${this.day}-requests.csv`
      } catch (e) {
        console.log(e)
        this.$store.dispatch('snack', e)
      } finally {
        this.inAction = false
      }
    },
    rubles (kops) {
      return (parseFloat(kops) / 100).toFixed(2)
    },
    saveAs () {
      const file = new File(
        [encoding.convert(this.csv, 'cp1251')],
        this.csvfilename,
        { type: 'text/plain;charset=cp1251' }
      )
      FileSaver.saveAs(file)
    },
  },
  watch: {
    day () {
      this.csv = null
      this.csvfilename = null
    }
  },
}
</script>
